var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("table", { staticClass: "w-100" }, [
        _c("tr", [
          _c("td", { staticClass: "w-50" }, [
            _c("div", { staticClass: "form-check mb-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value:
                      _vm.dutyCreate.duty
                        .preventAutoTriggeredActivityDuplicates,
                    expression:
                      "dutyCreate.duty.preventAutoTriggeredActivityDuplicates"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "checkbox",
                  id: "preventTriggeredActivityDuplicates" + _vm._uid
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.dutyCreate.duty.preventAutoTriggeredActivityDuplicates
                  )
                    ? _vm._i(
                        _vm.dutyCreate.duty
                          .preventAutoTriggeredActivityDuplicates,
                        null
                      ) > -1
                    : _vm.dutyCreate.duty.preventAutoTriggeredActivityDuplicates
                },
                on: {
                  change: function($event) {
                    var $$a =
                        _vm.dutyCreate.duty
                          .preventAutoTriggeredActivityDuplicates,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "preventAutoTriggeredActivityDuplicates",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "preventAutoTriggeredActivityDuplicates",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(
                        _vm.dutyCreate.duty,
                        "preventAutoTriggeredActivityDuplicates",
                        $$c
                      )
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: {
                    for: "preventTriggeredActivityDuplicates" + _vm._uid
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("dutyPreventTriggeredActivityDuplicates")) +
                      "\n                    "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "w-50" })
        ])
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "w-100" }, [
        _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("dutyIdent")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.identString,
                  expression: "dutyCreate.duty.identString"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.dutyCreate.duty.identString },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.dutyCreate.duty,
                    "identString",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check mb-2" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("dutyDesc")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.desc,
                  expression: "dutyCreate.duty.desc"
                }
              ],
              staticClass: "form-control text-area text-box",
              attrs: { type: "text" },
              domProps: { value: _vm.dutyCreate.duty.desc },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.dutyCreate.duty, "desc", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("ConditionBasedMonitoring", {
        attrs: { "duty-create": _vm.dutyCreate }
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("table", { staticClass: "w-100" }, [
        _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("dutyAutoCloseAfterDays")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.autoCloseAfterDays,
                  expression: "dutyCreate.duty.autoCloseAfterDays"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "number", min: "1" },
              domProps: { value: _vm.dutyCreate.duty.autoCloseAfterDays },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.dutyCreate.duty,
                    "autoCloseAfterDays",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }